<template>
  <div>
    <div class="relative">
      <!-- min-height: 4.5rem は３行分の高さを指定している -->
      <div
        class="overflow-hidden invisible whitespace-pre-wrap break-words w-full px-1 pt-1"
        style="min-height: 4.5rem;"
        v-text="internalText"
      />
      <textarea
        v-model.trim="text"
        style="min-height: 4.5rem;"
        :maxlength="max || undefined"
        :class="[
          'absolute top-0 left-0',
          'h-full w-full overflow-hidden resize-none px-2 py-1 outline-none',
          'rounded-md border border-gray-400',
          'placeholder-gray-400'
        ]"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useVModel } from '@vueuse/core';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyInputTextarea',
  props: {

    /**
     * 入力した文字
     */
    modelValue: {
      type: String,
      default: undefined,
    },

    /**
     * 最大文字数
     */
    max: {
      type: Number,
      default: 0,
    },

    /**
     * プレースホルダ
     */
    placeholder: {
      type: String,
      default: '入力してください',
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(prop) {
    const text = useVModel(prop, 'modelValue');

    // 空白行の高さを計算してくれるように末尾に空白を入れる。
    const internalText = computed(() => text.value + '\u200b');

    return {
      text,
      internalText,
    };
  },
});
</script>
